import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "@/shared/api/axios";
import { clearSession } from "./userSlice";

export const getIdolArray = createAsyncThunk(
  'idol/getIdolArray',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get("/idol/get-idol-array");
      return response.data;
    } catch (error) {
      // 保留攔截器附加的 httpErrorCode，讓呼叫端可交給 StatusModal（序列化後的 action.error 不含此欄位）
      return rejectWithValue(error.httpErrorCode);
    }
  }
);

export const idolSlice = createSlice({
  name: 'idol',
  initialState: {
    list: [],
  },
  reducers: {
    setIdolList(state, action) {
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIdolArray.fulfilled, (state, action) => {
        if (!Array.isArray(action.payload.data)) return;
        state.list = action.payload.data;
      })
      .addCase(clearSession, (state) => {
        state.list = [];
      });
  },
})

export const { setIdolList } = idolSlice.actions;

/**
 * 目前使用中的偶像是否已被停權（偶像停權鎖定狀態）。
 *
 * 由持久化的 idol.list + user.idolId 推算，不另存旗標：重新整理後立即可判斷，
 * 切換或創建偶像後 idolId 改變即自動解除。導頁、鎖定 modal、暫停偶像相關請求、
 * StatusModal 都讀這個 selector。
 *
 * 目前偶像不在列表中不算鎖定：刪除當前偶像的流程在「重抓列表」與「切換偶像」之間
 * 會短暫處於此狀態。
 */
export const selectIsIdolLocked = (state) => {
  const { token, idolId } = state.user;
  if (!token || !idolId) return false;
  const currentIdol = state.idol.list.find((idol) => idol.idol_id === idolId);
  return currentIdol !== undefined && currentIdol.idol_is_suspended === true;
};

/**
 * 偶像下拉選單的預設偶像：目前使用中的偶像；不在列表中則取第一個。停權偶像不可選，一律跳過。
 * 沒有可選的偶像時回傳 undefined。用於 IdolSelector 與 CreateTokenModal。
 */
export const getDefaultSelectableIdol = (idolList, currentIdolId) => {
  const selectableIdols = idolList.filter((idol) => !idol.idol_is_suspended);
  const currentIdol = selectableIdols.find((idol) => idol.idol_id === currentIdolId);
  return currentIdol !== undefined ? currentIdol : selectableIdols[0];
};
export default idolSlice.reducer;